import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunicationUiComponent } from './communication-ui.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";



@NgModule({
  declarations: [CommunicationUiComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule
  ],
  exports:[CommunicationUiComponent]
})
export class CommunicationUiModule { }
